import { define } from 'wicked-elements'
import onIntersect from 'on-intersect'

define('[data-component~="sidebar-logo"]', {
  init () {
    this.$header = document.getElementById('japan-story-logo')
    this.onEnter = this.onEnter.bind(this)
    this.onLeave = this.onLeave.bind(this)
  },
  connected () {
    this.stopObserving = onIntersect(this.$header, {}, this.onEnter, this.onLeave)
  },
  disconnected () {
    this.stopObserving()
  },
  onEnter () {
    this.element.style.visibility = 'hidden'
  },
  onLeave () {
    this.element.style.visibility = 'visible'
  }
})